
import { capitalizeEachWord } from '@dmm/lib-common/lib/formatting';
import {
  generateSearchPath,
  hyphenateUrlComponents
} from '../../../utils/urlHelpers/boats';
import { getClassCategory } from '../../../utils/classHelper';
import {
  BREAKPOINTS,
  unhyphenateUrlComponents
} from '../../../utils/commonHelper';
import { getTitle } from '../../../utils/listingHelper';

import {unslugify} from '../../../utils/urlHelpers/shared';
import { syncTranslationElements } from '../../../tppServices/translations/intlManager';

export const getBreadCrumb = (listing, breakpoint) => {
  const { formatMessage: t, messages } = syncTranslationElements();
  const breadcrumbs = [
    {
      title: t(messages.home),
      link: '/'
    },
    {
      title: t(messages.header.boatsForSale),
      link: generateSearchPath({})
    }
  ];

  const searchUrlParams = {};
  const makeBreadCrumb = (title, urlParams, formatTitle = true) => ({
    title: formatTitle
      ? capitalizeEachWord(unhyphenateUrlComponents(unslugify(title, '-', ' ')))
      : title,
    link: generateSearchPath(urlParams)
  });

  if (listing.type && listing.class) {
    const normalizedType = getClassCategory(listing.class);
    searchUrlParams.multiFacetedBoatTypeClass = {
      [listing.type]: []
    };
    breadcrumbs.push(
      makeBreadCrumb(t(messages.typesFacet[normalizedType]), searchUrlParams)
    );

    if (!messages.classFacetValues[listing.class]) {
      listing.class = 'power-unspec';
    }
    searchUrlParams.multiFacetedBoatTypeClass[listing.type].push(listing.class);
    breadcrumbs.push(
      makeBreadCrumb(
        t(messages.classFacetValues[listing.class]),
        searchUrlParams
      )
    );
  }
  if (listing.make) {
    const searchMakeUrlParams = {};
    searchMakeUrlParams.make = hyphenateUrlComponents(listing.make);
    breadcrumbs.push(makeBreadCrumb(listing.make, searchMakeUrlParams, false));
  }
  if (breakpoint === BREAKPOINTS.desktop) {
    breadcrumbs.push({
      title: getTitle(listing)
    });
  }

  return breadcrumbs;
};

export const nextPreviousMessages = (
  t,
  messages,
  isDesktop,
  longNextPrevious
) => {
  if (longNextPrevious) {
    return {
      nextBoat: t(messages.nextPrevious.next),
      prevBoat: t(messages.nextPrevious.previous),
      search: t(messages.nextPrevious.backToSearchBrokerShort)
    };
  }
  const nextBoat = isDesktop
    ? t(messages.nextPrevious.next)
    : t(messages.nextPrevious.nextShort);
  const prevBoat = isDesktop
    ? t(messages.nextPrevious.previous)
    : t(messages.nextPrevious.previousShort);
  const search = isDesktop
    ? t(messages.nextPrevious.backToSearch)
    : t(messages.nextPrevious.backToSearchShort);
  return { nextBoat, prevBoat, search };
};
